<template>
  <div>
    <v-container fluid class="py-6">
      <div class="d-sm-flex justify-between">
        <v-row class="mt-2 ">
        </v-row>
        <div class="d-flex ms-auto mt-4 mb-3">
          <v-btn
              elevation="0"
              :ripple="false"
              height="43"
              class="
              btn-outline-default
              font-weight-bold
              text-uppercase
              btn-default
              py-2
              px-6
              me-2
            "
              color="transparent"
              small
          >
            <v-icon size="16">fas fa-user me-1</v-icon>
            {{ batchInfo.organisation }}
          </v-btn>
          <v-btn
              v-if="false"
              elevation="0"
              :ripple="false"
              height="43"
              class="
              btn-outline-default
              font-weight-bold
              text-uppercase
              btn-default
              py-2
              px-6
              me-2
            "
              color="transparent"
              small
          >
            <v-icon size="16">fas fa-comment me-1</v-icon>
            {{ batchInfo.comment }}
          </v-btn>
          <v-btn
              elevation="0"
              :ripple="false"
              height="43"
              :class="
              batchInfo.status == 'Approved'
                    ? 'btn-outline-success'
                    : 'btn-outline-danger'"
              class="
              font-weight-bold
              text-uppercase
              btn-default btn-outline-danger
              py-2
              px-6
              me-2
            "
              color="transparent"
              small
          >
            <v-icon size="16">fa fa-bars me-1</v-icon>
            {{ batchInfo.status }}
          </v-btn>
          <v-btn
              v-if="$store.getters.is_finance"
              elevation="0"
              :ripple="false"
              height="43"
              class="
              font-weight-bold
              text-uppercase
              btn-default btn-outline-default
              py-2
              px-6
              me-2
            "
              color="transparent"
              small
          >
            <v-icon size="16">fas fa-dollar-sign me-1</v-icon>
            {{formatPrice(batchInfo.amount)}}
          </v-btn>
          <v-btn
              v-if="$store.getters.is_finance && batchInfo.status !== 'Pending Verification'"
              @click="openPdf(batchInfo.popUrl)"
              elevation="0"
              :ripple="false"
              height="43"
              class="
              font-weight-bold
              text-uppercase
              btn-default btn-outline-default
              py-2
              px-6
              me-2
            "
              color="transparent"
              small
          >
            <v-icon size="16">fas fa-file-pdf me-1</v-icon>
            View POP
          </v-btn>
        </div>
      </div>
      <v-row>
        <v-col cols="3"></v-col>
        <v-col cols="6"  v-if="$store.getters.is_finance">
          <v-card class="card-shadow border-radius-xl">
            <v-col sm="12" md="12" lg="12">
              <v-select
                  v-model="action"
                  label="Select Action"
                  item-value="value"
                  item-text="text"
                  :items="[{text: 'Pending Verification', value: 'Pending Verification'},
                          {text: 'Pending POP', value: 'Pending POP'},
                          {text: 'Pending Approval', value: 'Pending Approval'},
                          {text: 'Rejected', value: 'Rejected'},
                          {text: 'Approved', value: 'Approved'},
                         ]"
              ></v-select>
            </v-col>
            <v-col m="12" md="12" lg="12">
              <v-text-field
                  v-if="action === 'Rejected'"
                  v-model="reason"
                  label="Reason"
              >

              </v-text-field>
            </v-col>
            <v-col m="4" md="4" lg="4"></v-col>
            <v-col m="4" md="4" lg="4" class="align-center text-center">
              <v-btn
                  @click="updateBatchState()"
                  elevation="0"
                  :ripple="false"
                  height="43"
                  class="
            font-weight-bold
            text-uppercase
            btn-default
            bg-gradient-success
            py-2
            mt-2
            px-6
            me-2
            mb-sm-0 mb-2
          "
                  color="#5e72e4"
                  small
              >
                <v-icon size="16">fas fa-thumbs-up me-1</v-icon>
                UPDATE</v-btn
              >
            </v-col>
          </v-card>
        </v-col>
        <v-col cols="3"></v-col>
        <v-col cols="12">
          <v-card class="card-shadow border-radius-xl">
            <template>
              <div>
                <v-card class="card-shadow border-radius-xl mt-0">
                  <v-card-text class="px-0 py-0">
                    <v-data-table
                        :headers="headers"
                        :items="batchInfo.returns"
                        :search="search"
                        class="table"
                        :page.sync="page"
                        hide-default-footer
                        @page-count="pageCount = $event"
                        :items-per-page="itemsPerPage"
                        mobile-breakpoint="0"
                    >
                      <template v-slot:top>
                        <v-toolbar flat height="80">
                          <v-row>
                            <v-col cols="12" md="5">
                              <v-text-field
                                  hide-details
                                  class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      input-icon
                    "
                                  dense
                                  flat
                                  filled
                                  solo
                                  height="43"
                                  v-model="search"
                                  placeholder="Search"
                              >
                                <template slot="prepend-inner">
                                  <v-icon color="#adb5bd" size=".875rem"
                                  >fas fa-search</v-icon
                                  >
                                </template>
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </v-toolbar>
                      </template>

                      <template v-slot:item.id="{ item }">
                        <div class="d-flex align-center">
                          <v-checkbox
                              :ripple="false"
                              v-model="item.checkbox"
                              color="#141727"
                          ></v-checkbox>
                          <span class="my-2 text-xs text-body font-weight-bold">{{
                              item.id
                            }}</span>
                        </div>
                      </template>

                      <template v-slot:item.date="{ item }">
                        <span class="my-2 text-xs text-body font-weight-bold">{{
                            item.date
                          }}</span>
                      </template>

                      <template v-slot:item.general_fund="{ item }">
                        <span class="my-2 text-xs text-body font-weight-bold"> US$ {{
                            formatPrice(item.general_fund)
                          }}</span>
                      </template>

                      <template v-slot:item.status="{ item }">
                        <div class="d-flex align-center">
                          <v-btn
                              :ripple="false"
                              icon
                              outlined
                              rounded
                              width="25px"
                              height="25px"
                              class="me-2"
                              :class="
                  item.statusIcon == 'fas fa-check'
                    ? 'border-success'
                    : 'border-warning'
                "
                          >
                            <v-icon
                                size="8"
                                :class="
                    item.statusIcon == 'fas fa-check'
                      ? 'text-success'
                      : 'text-warning'
                  "
                            >
                              {{ item.statusIcon }}
                            </v-icon>
                          </v-btn>
                          <span class="text-body text-xs">{{ item.status }}</span>
                        </div>
                      </template>

                      <template v-slot:item.customer="{ item }">
                        <div class="d-flex align-center">
                          <v-avatar size="24" class="me-2" v-if="item.customerImg">
                            <v-img :src="item.customerImg"></v-img>
                          </v-avatar>

                          <v-avatar size="24" class="me-2 bg-gradient-default" v-else>
                            <span class="text-white text-xs">{{ item.customer[0] }}</span>
                          </v-avatar>
                          <span class="text-body text-xs font-weight-bold">{{
                              item.customer
                            }}</span>
                        </div>
                      </template>

                      <template v-slot:item.product="{ item }">
            <span class="my-2 text-xs text-body font-weight-bold">{{
                item.product
              }}</span>
                      </template>

                      <template v-slot:item.revenue="{ item }">
            <span class="my-2 text-xs text-body font-weight-bold">{{
                item.revenue
              }}</span>
                      </template>

                      <template v-slot:item.action="{ item }">
                        <v-btn
                            @click="goTo()"
                            elevation="0"
                            small
                            :ripple="false"
                            height="21"
                            class="
                    border-radius-sm
                    font-weight-bolder
                    px-2
                    py-2
                    badge-font-size
                    ms-auto
                    text-white text-xxs
                    mb-2
                  "
                            :class="
                    item.status == 'Approved'
                      ? 'bg-gradient-success'
                      : 'bg-gradient-warning'
                  "
                        >View</v-btn
                        >
                      </template>

                      <template v-slot:item.invoice="{ item }">
                        <v-btn
                            color="#fff"
                            class="text-dark font-weight-bolder px-1 shadow-0"
                            small
                            simple
                        >
                          <v-icon size="18" class="rotate-180"
                          >fas fa-file-pdf text-lg me-1</v-icon
                          >
                          Pdf
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-card-text>
                  <v-card-actions class="card-padding">
                    <v-row>
                      <v-col cols="6" lg="3" class="d-flex align-center">
                        <span class="text-body me-3 text-sm">Items per page:</span>
                        <v-text-field
                            hide-details
                            type="number"
                            outlined
                            min="-1"
                            max="15"
                            background-color="rgba(255,255,255,.9)"
                            color="rgba(0,0,0,.6)"
                            light
                            :value="itemsPerPage"
                            @input="itemsPerPage = parseInt($event, 10)"
                            placeholder="Items per page"
                            class="
                font-size-input
                placeholder-lighter
                text-color-light
                input-alternative input-focused-alternative input-icon
              "
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="6" class="ml-auto d-flex justify-end">
                        <v-pagination
                            prev-icon="fa fa-angle-left"
                            next-icon="fa fa-angle-right"
                            class="pagination"
                            color="#cb0c9f"
                            v-model="page"
                            :length="pageCount"
                            circle
                        ></v-pagination>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </div>
            </template>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog
          v-model="successDialog"
          max-width="290"
          persistent
      >
        <v-card class="text-center ">
          <v-card-title class="text-h5 justify-center">
            Success
          </v-card-title>

          <v-card-text>
            Status updated successfully.
          </v-card-text>

          <v-card-actions class="justify-center">
            <v-btn
                color="green darken-1"
                text
                outlined
                @click="goTo()"
            >
              Continue
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import AdminTableReturns from "./Widgets/AdminTableReturns.vue";
import returns from "@/views/Client/Orders/Widgets/Returns";
import axios from "axios";
import {mapState} from "vuex";

export default {
  name: "Returns-List",
  data() {
    return {
      page: 1,
      successDialog: false,
      pageCount: 0,
      itemsPerPage: 10,
      search: "",
      action: "",
      reason: "",
      batchInfo: [],
      headers: [
        {
          text: "Name",
          value: "emp_firstname",
          align: "middle",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "ID Number",
          value: "week_number",
          align: "middle",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Grade",
          value: "class_grade",
          align: "middle",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "General Fund",
          value: "general_fund",
          align: "middle",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
      ],
    };
  },
  components: {
    AdminTableReturns,
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  computed: {
    ...mapState(['base_url','is_agent','is_finance']),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    pages() {
      return this.pagination.rowsPerPage
          ? Math.ceil(this.items.length / this.pagination.rowsPerPage)
          : 0;
    },
  },
  created() {
    this.getBatchInfo()
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    async updateBatchState() {
    this.overlay = true
      const JWTToken = this.$store.getters.accessToken
      const payload = {
        "comment": this.reason,
        "status": this.action
      }
      const config = {
        method: "post",
        url: this.base_url + "/returns/update-batch-returns/" + this.$route.query.id,
        headers: {
          Authorization: `Bearer ${JWTToken}`,
          'Content-Type': 'application/json',
        },
        data: payload
      };
      axios(config)
          .then((response) => {
            if (response.status == '201') {
              this.getBatchInfo()
              this.overlay = false
              this.successDialog = true
            } else {
              console.log(response)
            }
            console.log(response)
          }).catch((error) => {
        console.log(error)
      });

    },
    async getBatchInfo() {
      const JWTToken = this.$store.getters.accessToken
      axios.get(this.base_url + '/returns/get-returns-info/' + this.$route.query.id, { headers: { Authorization: `Bearer ${JWTToken}` } })
          .then(res => {
            if (res.status === 200) {
              this.batchInfo = res.data
              console.log(this.batchInfo)
            } else if (res.status === 202) {
              console.log('202')
            } else {
              console.log('error')
            }
          })
    },
    openPdf (url) {
      let fullUrl = this.$store.state.download_url + url
      window.open(fullUrl);
    },
    goTo(){
      this.$router.push("/admin-returns");
    }
  },
};
</script>
